"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("@material-ui/core/colors");
var accent = {
  greenDark: '#2e784e',
  // same as greenMain, rgb(46, 120, 78)
  greenLight: '#e8f5e9',
  greenMain: '#2e784e',
  // rgb(46, 120, 78)
  limeDark: _colors.lime[900],
  limeLight: _colors.lime[200],
  limeMain: _colors.lime[500],
  orangeDark: '#a65f05',
  // same as orangeMain
  orangeLight: '#fff5db',
  orangeMain: '#a65f05',
  redDark: '#61021b',
  redLight: '#fee5eb',
  redMain: '#ab052f',
  // rgb(171, 5, 47)
  tealDark: _colors.teal[900],
  tealLight: _colors.teal[200],
  tealMain: _colors.teal[500]
};
var _default = accent;
exports["default"] = _default;